import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { CLIENT_INSURANCE_HISTORY } from 'api/query-keys';
import type { TClientInsuranceRes } from 'api/swagger';

interface IGetClientInsuranceHistoryParams {
  clientId: number;
  enabled?: boolean;
}

export const useGetClientInsuranceHistory = (params: IGetClientInsuranceHistoryParams) => {
  const { clientId, enabled = true } = params;

  return useQuery<TClientInsuranceRes[]>({
    queryKey: [CLIENT_INSURANCE_HISTORY, clientId],
    queryFn: async () => {
      const { data } = await http.get<TClientInsuranceRes[]>(`/v1/clients/${clientId}/insurance/history`);
      return data;
    },
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
